<app-private-header />
<router-outlet />
<app-private-footer />